import React from 'react';
import { Box, Typography } from '@mui/material';
import TeacherWeeklyTimetable from '../../components/Teacher/TeacherWeeklyTimetable';
import { useSupervisorTeacherContext } from '../../contexts/SupervisorTeacherContext';

const TeacherTimetable = () => {
  const picker = useSupervisorTeacherContext();
  const teacherIdParam = picker.isSupervisorPicker ? picker.selectedTeacherId : undefined;

  return (
    <Box>
      <Typography variant="h4" fontWeight={800} gutterBottom>
        Timetable
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {picker.isSupervisorPicker && picker.selectedTeacherName
          ? `Weekly calendar for ${picker.selectedTeacherName}. Use the header dropdown to switch teachers.`
          : 'Weekly calendar view of your sessions.'}
      </Typography>
      <TeacherWeeklyTimetable
        teacherId={teacherIdParam}
        viewingTeacherName={picker.selectedTeacherName}
        calendarTimezone={picker.selectedTeacherTimezone}
      />
    </Box>
  );
};

export default TeacherTimetable;

